import React, {useEffect, useState} from "react"
import {ReturnTextAndImg} from "../CheckImg"

export default function CheckboxAnswer({data, changeHandler, isPassed, userAnswers}) {
  const [answerUser,setAnswerUser] =useState({});
  const maxParameter = parseInt(data?.[0]?.parameter?.maxCheckNumber || '0');

  const onChangeCheckBox = (e) => {
    const checked = e.target.checked;
    const answerName = e.target.getAttribute('answername');
    const checkedCount = Object.values(answerUser).filter((value) => value).length;

    if (checkedCount < maxParameter || !checked || maxParameter === 0) {
      setAnswerUser((prevAnswerUser) => ({
        ...prevAnswerUser,
        [answerName]: checked,
      }));
      changeHandler(e);
    }
  };

  const styles = {
    right: {
      border: '3px solid rgba(128, 253, 195, 0.76)',
    },
    wrongUser: {
      border: '3px solid rgba(253, 128, 128, 0.76)',
    },
  }

  const getAnswerStyle = (data, isPassed, userAnswers) => {
    if (isPassed) {
      if (data.percent > 0) {
        return styles.right;
      } else if (userAnswers[data.name] && data.percent <= 0) {
        return styles.wrongUser;
      }
    }
    return null;
  };

  const answer = data.map((item,i)=>{
    const text = ReturnTextAndImg(item.name);
    const style = getAnswerStyle(item, isPassed, userAnswers);

    return <label className="test-answer-general" style={style} key={item.name+'key'+i}>
      <input onChange={(e) => onChangeCheckBox(e)}
             answername={item.name}
             name={item.name}
             type="checkbox"
             disabled={isPassed}
             checked={answerUser?.[item.name]||false}
      />
      {text}
    </label>
  })

  return (
      <>
        {answer}
      </>
  )
}